import PropTypes from 'prop-types';
import { createContext, useContext, useMemo, useState } from 'react';
import { DEFAULT_PRODUCT_CURRENCY_CODE } from '@/utils/currency';

const FinancialCurrencyContext = createContext({
  selectedCurrency: DEFAULT_PRODUCT_CURRENCY_CODE,
  setSelectedCurrency: () => {},
});

export function FinancialCurrencyProvider({ children }) {
  const [selectedCurrency, setSelectedCurrency] = useState(DEFAULT_PRODUCT_CURRENCY_CODE);

  const value = useMemo(
    () => ({
      selectedCurrency,
      setSelectedCurrency,
    }),
    [selectedCurrency]
  );

  return (
    <FinancialCurrencyContext.Provider value={value}>
      {children}
    </FinancialCurrencyContext.Provider>
  );
}

FinancialCurrencyProvider.propTypes = {
  children: PropTypes.node,
};

export const useFinancialCurrency = () => useContext(FinancialCurrencyContext);
